export const buildPriceDisplaySelections = (
  selections: Gallery.ContentQuery.ProductOptions,
  quantity?: Gallery.Models.Url.ValidParsedQsValue<number>,
): Gallery.ContentQuery.ProductOptions => ((quantity ?? 0) > 0 ? { ...selections, quantity: String(quantity) } : selections)
